import type { ChartLayout } from "./types";

const HANDLE_RADIUS = 5;

export function applyLineStyle(
  ctx: CanvasRenderingContext2D,
  color: string,
  width: number,
  opacity: number,
) {
  ctx.strokeStyle = color;
  ctx.lineWidth = width;
  ctx.globalAlpha = opacity / 100;
}

export function clipToChart(ctx: CanvasRenderingContext2D, layout: ChartLayout) {
  const { left, top, width, height, right, bottom } = layout;
  ctx.beginPath();
  ctx.rect(left, top, width - left - right, height - top - bottom);
  ctx.clip();
}

export function drawHandleCircle(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  color: string,
) {
  ctx.globalAlpha = 1;
  ctx.beginPath();
  ctx.arc(x, y, HANDLE_RADIUS, 0, Math.PI * 2);
  ctx.fillStyle = color;
  ctx.fill();
  ctx.strokeStyle = "#ffffff";
  ctx.lineWidth = 1.5;
  ctx.stroke();
}
